import { useEffect, useState } from "react";
import "./AppEmployeeTimeOff.css";
import { CompanyHoliday, CompanyHolidayType, TimeOffRequest, TimeOffRequestExtended, TimeOffRequestStatus } from "winslow-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { apiGetCompanyHolidaysForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { convertToLocalTimezone, getLastWeekdayOfMonth, getNthDayOfWeek } from "./companyHolidayUtils";
import { CurrentYearHoliday } from "../app-calendar/AppCalendar";
import { AppCompanyHolidaysPreview } from "./AppCompanyHolidaysPreview";
import { apiGetTimeOffRequest, apiGetTimeOffRequestsForEmployeeRecord } from "../../../services/TimeOffRequestService";
import { AppEmployeeTimeOffRequestCard } from "./AppEmployeeTimeOffRequestCard";
import { TimeOffRequestStatusLabels } from "winslow-core";
import { AppEmployeeTimeOffBalancesCard } from "./AppEmployeeTimeOffBalancesCard";

type AppEmployeeTimeOffProps = {
}

export const AppEmployeeTimeOff = ({} : AppEmployeeTimeOffProps) => {

    const storeUser = useSelector(selectUser);

    const [nextHoliday, setNextHoliday] = useState<CurrentYearHoliday | undefined>(undefined);
    const [companyHolidays, setCompanyHolidays] = useState<CompanyHoliday[]>([]);
    const [currentYearHolidays, setCurrentYearHolidays] = useState<CurrentYearHoliday[]>([]);
    const [showHolidays, setShowHolidays] = useState(false);
    const [showPrevious, setShowPrevious] = useState(false);

    const [timeOffRequests, setTimeOffRequests] = useState<TimeOffRequestExtended[]>([]);

   useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        (async () => {
            const theHolidays = await apiGetCompanyHolidaysForWorkspace(storeUser.currentWorkspaceId || "");

            if (theHolidays) {
                setCompanyHolidays(theHolidays);
            }

            const theRequests = await apiGetTimeOffRequestsForEmployeeRecord(storeUser.employeeRecordId || "");

            if (theRequests) {
                setTimeOffRequests(theRequests);
            }
        })();
    }, [storeUser]);
   
    useEffect(() => {
        if (companyHolidays) {
            const holidaysProcessed = companyHolidays.map((holiday) => {
                const currentDate = new Date();
                let currentYear: Date | null = null;

                switch (holiday.type) {
                    case CompanyHolidayType.DATE:
                        if (holiday.date) {
                            const useDate = convertToLocalTimezone(holiday.date);
                            currentYear = new Date(currentDate.getFullYear(), useDate.getMonth(), useDate.getDate());

                            console.log("[AppCompanyHolidays] holiday.date: ", holiday.date);
                            console.log("[AppCompanyHolidays] useDate: ", useDate);
                            console.log("[AppCompanyHolidays] currentYear: ", currentYear);
                        }
                        break;
                    case CompanyHolidayType.NTH:
                        if (holiday.nth && holiday.dayOfWeek && holiday.month) {
                            currentYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, currentDate.getFullYear());
                        }
                        break;
                    case CompanyHolidayType.LAST:
                        if (holiday.dayOfWeek && holiday.month) {
                            currentYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, currentDate.getFullYear());
                        }
                        break;  
                    // case CompanyHolidayType.DAY_AFTER:
                    //     if (holiday.date) {
                    //         const nextDay = getNextDay(holiday.date);
                    //         thisYear = new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate());
                    //         nextYear = new Date(nextDay.getFullYear() + 1, nextDay.getMonth(), nextDay.getDate());
                    //     }
                }

                return {
                    name: holiday.name,
                    date: currentYear
                } as CurrentYearHoliday;
            })

            setCurrentYearHolidays(holidaysProcessed);

            // loop through the processed holidays and find the next holiday
            const today = new Date();
            let nextHoliday: CurrentYearHoliday | undefined = undefined;

            for (let i = 0; i < holidaysProcessed.length; i++) {
                const holiday = holidaysProcessed[i];
                if (holiday.date && holiday.date > today) {
                    nextHoliday = holiday;
                    break;
                }
            }

            if (nextHoliday) {
                setNextHoliday(nextHoliday);
            }
        }
    }, [companyHolidays]);

    const formatDate = (date: any) => {
        return new Intl.DateTimeFormat('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }).format(new Date(date));
    };

    const upcomingTimeOff = timeOffRequests.filter((request) => {
        const startDate = new Date(request.startDate);
        const endDate = new Date(request.endDate);
        const today = new Date();
        return startDate >= today;
    });

    const currentTimeOff = timeOffRequests.filter((request) => {
        const startDate = new Date(request.startDate);
        const endDate = new Date(request.endDate);
        const today = new Date();
        return startDate <= today && endDate >= today;
    });

    const activeTimeOff = [...upcomingTimeOff, ...currentTimeOff];

    const pastTimeOff = timeOffRequests.filter((request) => {
        const startDate = new Date(request.startDate);
        const endDate = new Date(request.endDate);
        const today = new Date();
        return endDate < today;
    });

    activeTimeOff.sort((a, b) => {
        const startA = new Date(a.startDate);
        const startB = new Date(b.startDate);
        return startA.getTime() - startB.getTime();
    });

    pastTimeOff.sort((a, b) => {
        const startA = new Date(a.startDate);
        const startB = new Date(b.startDate);
        return startA.getTime() - startB.getTime();
    });

    console.log("[AppEmployeeTimeOff] companyHolidays: ", companyHolidays);
    console.log("[AppEmployeeTimeOff] currentYearHolidays: ", currentYearHolidays);
    console.log("[AppEmployeeTimeOff] nextHoliday: ", nextHoliday);
    console.log("[AppEmployeeTimeOff] upcomingTimeOff: ", upcomingTimeOff);
    console.log("[AppEmployeeTimeOff] currentTimeOff: ", currentTimeOff);
    console.log("[AppEmployeeTimeOff] pastTimeOff: ", pastTimeOff);

    return (
        <div className="app-employee-time-off">
            <div className="app-employee-time-off-next-holiday">

                <div className="app-employee-time-off-next-holiday-date">
                    <span>{nextHoliday ? nextHoliday.name : "No holidays found"}</span>
                    <span>{nextHoliday ? formatDate(nextHoliday.date) : ""}</span>
                </div>
                <div 
                    className="app-employee-time-off-next-holiday-show"
                    onClick={() => {
                        setShowHolidays(!showHolidays);
                        console.log("Show all holidays clicked");
                    }}
                >
                    Show All Holidays 
                </div>
            </div>
            {showHolidays &&
                <AppCompanyHolidaysPreview
                    companyHolidays={companyHolidays}
                />
            }

            <div className="app-employee-time-off-pto-section">
                <div className="app-employee-time-off-left">
                    <div className="app-employee-time-off-pto">
                        <div className="app-employee-time-off-pto-header">
                            <h2>Upcoming Time Off</h2>
                            {/* <div className="app-employee-time-off-pto-header-actions">
                                <span
                                    onClick={() => {
                                        setShowPrevious(!showPrevious);
                                    }}
                                >
                                    Show Previous
                                </span>
                            </div> */}
                        </div>
                        
                        {upcomingTimeOff.length > 0 ? (
                            <div className="app-employee-time-off-pto-upcoming">
                                {activeTimeOff.map((request, index) => (
                                    <div 
                                        className="app-employee-time-off-request"
                                        key={index}
                                    >
                                        <AppEmployeeTimeOffRequestCard
                                            timeOffRequest={request}
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>No upcoming time off requests.</p>
                        )}
                    </div>

                    <div className="app-employee-time-off-pto">
                        <h2>History</h2>
                        {pastTimeOff.length > 0 ? (
                            <div className="app-employee-time-off-pto-upcoming">
                                {pastTimeOff.map((request, index) => (
                                    <div 
                                        className="app-employee-time-off-request"
                                        key={index}
                                    >
                                        <div className="app-employee-time-off-request-status">
                                            {TimeOffRequestStatusLabels[request.status]}
                                        </div>
                                        <div className="app-employee-time-off-request-type">
                                            {request?.paidTimeOffPolicy.name}
                                        </div>
                                        <div className="app-employee-time-off-request-dates">
                                            {formatDate(request.startDate)} to {formatDate(request.endDate)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>No past time off requests.</p>
                        )}
                    </div>
                </div>
                <div className="app-employee-time-off-right">
                    <AppEmployeeTimeOffBalancesCard  employeeRecordId={storeUser?.employeeRecordId || ""}/>
                </div>
            </div>
        </div>
    )
}